export default "/images/silver_lock.png?c97d71e9d9b887f32dbab0ae73b32062";